import { catchError } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { Config } from '@shared/configs/config';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { ProjectCreatorApiService } from '../services/project-creator-api.service';
import { NavigateService } from '@shared/services/navigate.service';

@Injectable()
export class ProjectCreatorManageResolver  {
  constructor(
    private api: ProjectCreatorApiService,
    private n: NavigateService
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.api.getFullProjectData(route.params.token).pipe(
      catchError((error) => {
        Config.DEBUG ? console.log(error) : null;
        this.n.go('/', {}, { replaceUrl: true });
        return of(error);
      })
    );
  }
}
